import { useCallback, useContext, useEffect, useState } from 'react';
import { SocketContext } from '../../contexts/SocketContext';
import { LoaderContext } from '../../contexts/LoaderContext';
import { AlertContext } from '../../contexts/AlertContext';
import { convertirLetraMayus } from '../../helpers/convertirLetraMayus';
import { formatearFecha } from '../../helpers/fechaHoras';
import { AuthContext } from '../../contexts/AuthContext';
import { Actions } from '../../components/surveys/responses/Actions';
import { IconButton, Tooltip } from '@mui/material';
import dayjs from 'dayjs';

const columns = [
    { id: "titulo_encuesta", label: "Encuesta", minWidth: 170, align: 'center' },
    { id: "creado", label: "Fecha", minWidth: 170, align: 'center' },
    { id: "canal", label: "Canal", minWidth: 170, align: 'center' },
    { id: "servicio", label: "Servicio", minWidth: 170, align: 'center' },
    { id: "sede", label: "Sede", minWidth: 170, align: 'center' },
    { id: "usuario", label: "Evaluado", minWidth: 170, align: 'center' },
    { id: "pqrs", label: "PQRS", minWidth: 0, align: 'center' },
    { id: "acciones", label: "Acciones", minWidth: 170, align: 'center' }
];

export const useResponses = (loading = false) => {

    const [responses, setResponses] = useState([]);
    const [total, setTotal] = useState(0);

    const { usuario } = useContext(AuthContext);
    const { socket } = useContext(SocketContext);
    const { alertRef } = useContext(AlertContext);
    const { setOpenLoader } = useContext(LoaderContext);

    useEffect(() => {
        let subscribed = true;
        
        subscribed && getResponses();

        return () => subscribed = false;
    }, []);

    const searchResponses = (value) => { 
        socket.emit('frontend:buscar-respuestas', { codigo: value?.toLowerCase().trim() }, response => {
            const { ok, message, total, data } = response;

            if(!ok) {
                alertRef.current?.handleOpen('error', message);
                return;
            }
            
            setResponses(data?.map(s => generatePayload(s)));
            setTotal(total);
        });
    }

    const getResponses = useCallback(() => {
        loading && setOpenLoader(true);
        socket.emit('frontend:obtener-respuestas', (response) => {
            const { ok, message, total, data } = response;
            let newArr = [];

            if(!ok) {
                setOpenLoader(false);
                alertRef.current?.handleOpen('error', message);
                return;
            }

            if(usuario?.rol?.nombre?.includes('admin') || usuario?.rol?.nombre?.includes('super')) {
                newArr = data?.map(generatePayload);
            }else {
                newArr = data?.filter(r => r?.encuesta?.area?._id === usuario?.area).map(generatePayload);
            }
            
            setResponses(newArr);
            setTotal(total);
            setOpenLoader(false);
        });
    }, []);

    const saveResponse = async (args) => {
        const response = await fetch('https://api.ipify.org?format=json');
        const { ip } = await response.json();
        
        socket.emit('frontend:crear-respuesta', { ...args, ip: ip || '' }, response => {
            const { ok, message, data } = response;

            if(!ok) {
                alertRef.current?.handleOpen('error', message);
                return;
            }

            setResponses(prev => ([...prev, generatePayload(data)]));
            setOpenLoader(false);
        });
    }

    const generatePayload = (data) => ({
        ...data,
        titulo_encuesta: GroupData(convertirLetraMayus(data?.titulo_encuesta), convertirLetraMayus(data?.codigo_encuesta)),
        creado: GroupData(formatearFecha(data?.creado), dayjs(data?.creado)?.format('hh:mm:ss A')),
        canal: convertirLetraMayus(data?.canal),
        servicio: convertirLetraMayus(data?.servicio),
        sede: convertirLetraMayus(data?.sede),
        usuario: data?.usuario ? convertirLetraMayus(data?.usuario, true) : 'N/A',
        pqrs: <Pqrs data={ data } />,
        acciones: <Actions data={ data }  />
    });
    
    return {
        columns,
        responses,
        saveResponse,
        searchResponses,
        total
    }
}

const GroupData = (title, subtitle) => (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span>{ title }</span>
        <span style={{ fontSize: 12, fontWeight: 600 }}>{ subtitle }</span>
    </div>
);

const Pqrs = ({ data }) => {

    const question = data?.preguntas?.find(p => p?.pqrs);

    if(!question?.pqrs) return <span style={{ fontSize: 14, fontWeight: 600, color: '#494949' }}>N/A</span>

    return (
        <Tooltip title={ `${ convertirLetraMayus(question?.pqrs) }: ${ convertirLetraMayus(question?.respuesta) }` }>
             <IconButton aria-label="read">
                <span style={{ fontSize: 14, fontWeight: 600, width: 18, color: '#494949' }}>{ question?.pqrs?.charAt(0)?.toUpperCase() }</span>
             </IconButton>
        </Tooltip>
    );
}